var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk02430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.8 30",
    style: {
      enableBackground: "new 0 0 58.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.7619 22.1868)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 4.1179 49.8019)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30H28.7V0h30.1V30z M29.9,28.8h27.8V1.2H29.9V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,25.9H32.1V3.7h22.8V25.9z M33.3,24.8h20.5v-20H33.3V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -1.6132 8.683)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -10.3015 24.9026)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,25.9H3.4V3.7h22.8V25.9z M4.6,24.8H25v-20H4.6V24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk02430);
export default __webpack_public_path__ + "static/media/AK0_2_43_0.fbf63a90627132e4e9678d8d26a30eb9.svg";
export { ForwardRef as ReactComponent };